import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  FloatSidebar,
  FloatSidebarList,
  FloatSidebarListItem
} from 'common/components';
import { useExpandedIds } from 'common/hooks';
import { Col } from 'react-bootstrap';

import { getSelectScriptColumns } from '../../../utils';
import { CustomLink } from '../../link';
import { SqlFloatSidebarForm } from './SqlFloatSidebarForm';

const SqlsFloatSidebar = ({
  sqls,
  onAddSqls,
  onRemoveSqls,
  sqlModeloService
}) => {
  const { expandedIds, handleExpandedIds } = useExpandedIds();

  const onDragStart = (event, objeto, alias) => {
    event.dataTransfer.setData(
      'text/html',
      `<span contenteditable="false">[[${objeto.identificador}.${alias}]]</span>`
    );
  };

  const getSqlColumnsAliases = script => {
    const scriptColumns = getSelectScriptColumns(script);

    return scriptColumns
      ? scriptColumns[1]
          .trim()
          .replaceAll(/\(([^)]+)\)/gm, '')
          .replaceAll(/(?:case).*(?=end)/gim, () => '')
          .split(',')
          .map(s => s.trim().split(' as '))
          .map(([_, alias]) => alias)
      : [];
  };

  return (
    <>
      <FloatSidebar hint title="Variáveis/Sqls">
        <SqlFloatSidebarForm
          onAddSql={onAddSqls}
          sqls={sqls}
          sqlModeloService={sqlModeloService}
        />
        <FloatSidebarList
          placeholder="Busca de Variáveis/Sqls"
          showTopDivider={true}
          showFilter={false}
        >
          {sqls.map((objeto, index) => (
            <FloatSidebarListItem key={objeto.id}>
              <Col md={12}>
                <FontAwesomeIcon
                  className="chip-icon-right"
                  icon="trash"
                  onClick={() =>
                    onRemoveSqls(sqls.findIndex(sql => sql.id === objeto.id))
                  }
                />
                <Col md={11}>
                  <b className="module-color col-md-4 pl-none pr-none">
                    Código:
                  </b>
                  <CustomLink
                    identificador={`${objeto.id}`}
                    uri={`/variaveis/${objeto.id}`}
                  />
                </Col>
              </Col>

              <Col md={12}>
                <Col md={11}>
                  <b className="module-color col-md-4 pl-none pr-none">Nome:</b>
                  {objeto.nome}
                </Col>
              </Col>

              <Col md={12}>
                <FontAwesomeIcon
                  className="chip-icon-right"
                  icon={
                    expandedIds.some(i => i === index)
                      ? 'chevron-up'
                      : 'chevron-down'
                  }
                  onClick={() => handleExpandedIds(index)}
                />
                <Col md={11}>
                  <b className="module-color col-md-4 pl-none pr-none">
                    Identificador:
                  </b>
                  {objeto.identificador}
                </Col>
              </Col>
              {expandedIds.some(i => i === index) && (
                <Col md={12}>
                  <div className="row">
                    <div className="title-block">Colunas</div>
                  </div>
                  <div className="col-md-12 pl-none pr-none">
                    {getSqlColumnsAliases(objeto.script).map(alias => (
                      <FloatSidebarListItem
                        key={`alias_${objeto.id}_${alias}`}
                        draggable={true}
                        onDragStart={e => onDragStart(e, objeto, alias)}
                      >
                        <Col md={12}>{alias}</Col>
                      </FloatSidebarListItem>
                    ))}
                  </div>
                </Col>
              )}
            </FloatSidebarListItem>
          ))}
        </FloatSidebarList>
      </FloatSidebar>
    </>
  );
};

export { SqlsFloatSidebar };
